import controller from './events.controller';
import templateBase from './views/events.view.html';
import templateAD from './views/events.adaptative.html';

let EventsComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

function changeTemplate() {
  if(__env.adaptative){
    return templateAD;
  } else {
    return templateBase;
  }
}

export default EventsComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/events/events.component.js
 **/